// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E3ua","select":"styles_select__3mYcF"};